/* cf-inspection-days.js - Click Fencing site inspections: never offer a weekend or a WA public holiday.
   Pete, 3 Oct 2026: "lets not allow any click site inspections on weekends or public holidays".

   Two day pickers can book a Click site inspection:
     1. /pages/book-a-site-inspection   <select id="cf-date">      (built inline by templates/page.book-inspection.liquid)
     2. /pages/quote-review "Get it Installed"  <select id="cf-si-date">  (built by assets/cf-one-price.js, only once the
        customer picks the inspection route, so it can appear at any time after load)
   Both already list Monday-Friday only. This script removes any option that is a Saturday, Sunday or WA public holiday, so
   the pickers stay correct even if those builders change, and removes the holidays they never knew about.

   HOLIDAYS: fetched from the public read-only edge function `public-holidays` (reads public.public_holidays, kept to the end of
   2027). If that call fails the static copy below is used, so a holiday is never offered because of a network blip.
   Refresh the static copy when public_holidays is extended. It changes no wording and posts nothing.
   The CRM and click-inspection-intake enforce the same rule server-side; this script is the first line, not the only one. */
(function () {
  if (window.__cfInspectionDays) return;
  window.__cfInspectionDays = true;

  var URL_HOLIDAYS = 'https://mhzmtafzxeshqqtktbwh.supabase.co/functions/v1/public-holidays';
  var holidays = {};
  ['2026-12-25', '2026-12-28', '2027-01-01', '2027-01-26', '2027-03-01', '2027-03-26', '2027-03-29', '2027-04-26',
   '2027-06-07', '2027-09-27', '2027-12-27', '2027-12-28'].forEach(function (d) { holidays[d] = 1; });

  var MON = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12 };
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* "Mon 7 Sep 2026" -> {iso, dow} or null */
  function parse(label) {
    var m = /(\d{1,2})\s+([A-Za-z]{3,9})\s+(\d{4})/.exec(String(label || ''));
    if (!m) return null;
    var mon = MON[m[2].slice(0, 3).toLowerCase()];
    if (!mon) return null;
    var dow = new Date(Date.UTC(+m[3], mon - 1, +m[1])).getUTCDay();
    return { iso: m[3] + '-' + pad(mon) + '-' + pad(+m[1]), dow: dow };
  }
  function allowed(label) {
    var p = parse(label);
    if (!p) return true;                       /* not a date option (placeholder) - leave it */
    if (p.dow === 0 || p.dow === 6) return false;
    return !holidays[p.iso];
  }

  function clean(sel) {
    if (!sel || !sel.options) return;
    var stamp = sel.options.length + ':' + Object.keys(holidays).length;
    if (sel.getAttribute('data-cf-days') === stamp) return;
    var chosen = sel.value, dropped = false;
    for (var i = sel.options.length - 1; i >= 0; i--) {
      var o = sel.options[i];
      if (!o.value) continue;
      if (!allowed(o.value || o.textContent)) { sel.removeChild(o); dropped = true; }
    }
    if (dropped && chosen && !allowed(chosen)) sel.value = '';
    sel.setAttribute('data-cf-days', sel.options.length + ':' + Object.keys(holidays).length);
  }
  function sweep() {
    clean(document.getElementById('cf-date'));
    clean(document.getElementById('cf-si-date'));
  }

  /* run now (static list), then again once the live list arrives */
  function start() {
    sweep();
    try {
      var mo = new MutationObserver(function () { sweep(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    try {
      fetch(URL_HOLIDAYS, { method: 'GET' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (j && j.dates && j.dates.length) {
          j.dates.forEach(function (d) { holidays[d] = 1; });
          sweep();
        }
      }).catch(function () {});
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
